module.exports = __webpack_public_path__ + "img/speech_03.d8bdd0b8.svg";